import { render, staticRenderFns } from "./FormCrudUser.vue?vue&type=template&id=2c9fa347&scoped=true&"
import script from "./FormCrudUser.vue?vue&type=script&lang=js&"
export * from "./FormCrudUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9fa347",
  null
  
)

export default component.exports